// Node Modules
import {
  useEffect, useState 
} from 'react';

// Components
import SearchSidebar from '@/components/global-components/search-sidebar/SearchSidebar';
import SocialNetwork from '@/components/global-components/SocialNetwork';
import Cards from '@/components/global-components/cards/Cards';
import Header from './header/Header';
import Information from './information/Information';
import Container from '@/components/global-components/Container';

// Queries
import { getRecentPostsContent } from '@/graphql/shared/posts'

// Scripts
import { fetchPosts } from '@/services/posts'

// Themes
import theme from '@/themes/index';

const PostBody = ({
  content: {
    postsInfo,
    posts,
  },
  isMobile,
  isDesktop,
}) => {
  const [recentPosts, setRecentPosts] = useState([]);
  const [postsInfoState, setPostsInfo] = useState(postsInfo);

  const post = posts[0]?.node || {};

  const getPost = async (first, last, searchText, beforeCursor, afterCursor) => {
    return await fetchPosts(first, last, searchText, beforeCursor, afterCursor)
      .catch(function (error) {
        console.log('ERROR: ', error);
      })
  }
  
  async function getRecentPosts() {
    const response = await fetchPosts(4, null, '', '', '')
      .catch(function (error) {
        console.log('ERROR: ', error);
      });

    setRecentPosts(response.data.posts)
  }
  
  async function checkIfHasNext(cursor) {
    const result = await getPost(1, null, '', '', cursor);

    if(result.data.posts.length) {
      setPostsInfo({
        ...postsInfoState,
        pageInfo: {
          ...postsInfo.pageInfo,
          hasNextPage: true,
        },
      })
    }
  }

  async function checkIfHasPrevious(cursor) {
    const result = await getPost(null, 1, '', cursor, '');
    if(result.data.posts.length) {
      setPostsInfo({
        ...postsInfoState,
        pageInfo: {
          ...postsInfo.pageInfo,
          hasPreviousPage: true,
        },
      })
    }
  }

  useEffect(() => {
    getRecentPosts();
    checkIfHasNext(postsInfo.pageInfo.endCursor);
    checkIfHasPrevious(postsInfo.pageInfo.startCursor);
  }, []);

  return (
    <>
      <section className='post'>
        <Container>
          <div className='post-layout'>
            <div className='post-container'>
              <div className='content'>
                <Header content={post} />
                <Information content={post} isDesktop={isDesktop} />
              </div>
              {/* <div className='social-network'> 
                <SocialNetwork
                  icons={post?.social?.socialNetworks}
                  backgroundColor={theme.backgroundColors.optional2}
                />
              </div>*/}
            </div>
            <div className='recent-post-container'>
              <SearchSidebar recentPosts={recentPosts} showSearchBar={false} />
            </div>
          </div>
        </Container>
        <div className="recent-posts">
          <Cards
            isMobile={isMobile}
            isDesktop={isDesktop}
            content={getRecentPostsContent(recentPosts.slice(0, 3))}
            showAlternateHeader={true}
          />
        </div>
      </section>
      <style jsx>{`
        div.post-layout {
          padding: 8rem 0.625rem 3rem;
          display: flex;
          flex-direction: column-reverse;
        }

        div.post-layout .recent-post-container {
          padding-bottom: 3rem;
        }

        div.recent-posts {
          padding: 1rem 0.625rem 8rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.post-layout {
            flex-direction: inherit;
            gap: 4.438rem;
          }

          div.post-layout .recent-post-container {
            padding-bottom: 0;
          }

          div.post-layout .post-container .social-network {
            display: flex;
            justify-content: flex-end;
            padding-top: 2.325rem;
          }

          div.recent-posts h5 {
            margin-block-start: 0;
            margin-block-end: 0;
          }
        }
      `}</style>
      <style global jsx>{`
        div.recent-posts .container .header-container h6 {
          font-size: 1.25rem;
          line-height: 1.875rem;
          font-family: ${theme.fontFamilies.montserrat};
          text-decoration: none;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.post-layout .post-container .pagination-container .pagination {
            margin-top: 3.688rem;
          }

          div.post-layout .post-container .social-network .icons-container {
            box-sizing: content-box;
          }

          div.recent-posts .container .header-container h6 {
            font-size: 2rem;
            line-height: 3rem;
          }
        }
      `}</style>
    </>
  );
};

export default PostBody;